export { default } from "./AutomationDetails";
